"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoolAvailability = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const PoolAvailabilityVehicle_1 = require("./PoolAvailabilityVehicle");
let PoolAvailability = class PoolAvailability {
    priceNonrefundable;
    customPickup;
    customDropoff;
    priceFlexible;
    priceSuperFlexible;
    timezone;
    departureTimeEarliest; // in seconds
    departureTimeLatest; // in seconds
    masterTimeEarliest; // in seconds
    masterTimeLatest; // in seconds
    cutoffTime;
    cutoffTimeWithChildren;
    sightseeing;
    availableSeats;
    honoredPeriod; // time period in seconds until the offer expires
    honoredPriceCoefficient; // a coeficient of the price that is still acceptable if the price changes
    totalVehicles = [];
    etaOffset;
    etaPeriod;
    unavailableMeetingPositionIds;
    unavailableDropoffPositionIds = [];
};
exports.PoolAvailability = PoolAvailability;
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], PoolAvailability.prototype, "priceNonrefundable", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], PoolAvailability.prototype, "customPickup", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], PoolAvailability.prototype, "customDropoff", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], PoolAvailability.prototype, "priceFlexible", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], PoolAvailability.prototype, "priceSuperFlexible", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], PoolAvailability.prototype, "timezone", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], PoolAvailability.prototype, "departureTimeEarliest", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], PoolAvailability.prototype, "departureTimeLatest", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], PoolAvailability.prototype, "masterTimeEarliest", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], PoolAvailability.prototype, "masterTimeLatest", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], PoolAvailability.prototype, "cutoffTime", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], PoolAvailability.prototype, "cutoffTimeWithChildren", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], PoolAvailability.prototype, "sightseeing", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], PoolAvailability.prototype, "availableSeats", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], PoolAvailability.prototype, "honoredPeriod", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], PoolAvailability.prototype, "honoredPriceCoefficient", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => PoolAvailabilityVehicle_1.PoolAvailabilityVehicle),
    __metadata("design:type", Array)
], PoolAvailability.prototype, "totalVehicles", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], PoolAvailability.prototype, "etaOffset", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], PoolAvailability.prototype, "etaPeriod", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => String),
    __metadata("design:type", Array)
], PoolAvailability.prototype, "unavailableMeetingPositionIds", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => String),
    __metadata("design:type", Array)
], PoolAvailability.prototype, "unavailableDropoffPositionIds", void 0);
exports.PoolAvailability = PoolAvailability = __decorate([
    (0, class_transformer_1.Exclude)()
], PoolAvailability);
//# sourceMappingURL=PoolAvailability.js.map